import { AfterViewInit, Component, Inject, OnDestroy, OnInit, Type, inject } from '@angular/core';
import moment from 'moment';

import { InvestimentsBase } from '../investiments.base';
import { StocksService } from './stocks.service';
import { StockCreateComponent } from './create/create.component';
import { StockModifyComponent } from './modify/modify.component';

@Component({
  selector: 'app-stocks',
  standalone: false,
  templateUrl: './stocks.component.html',
  styleUrl: './stocks.component.scss'
})
export class StocksComponent extends InvestimentsBase<StockCreateComponent, StockModifyComponent> implements AfterViewInit {

  override service = inject(StocksService)

  override list : any = {
    columns: [
      'share', 'side', 'amount', 'price', 'tax', 'total', 'date', 'action'
    ],
    data: [
      // { id: 1, share: 'CXSE3', date: moment('2024-07-01').format('YYYY-MM-DD'), side:  'BUY', amount: '100', price:  0.50, tax: 10.10, total:  60.10, attach: 1  },
      // { id: 2, share: 'ITSA4', date: moment('2024-07-01').format('YYYY-MM-DD'), side:  'BUY', amount:  '25', price: 30.00, tax: 10.20, total: 760.20, attach: '' },
      // { id: 3, share: 'KLBN4', date: moment('2024-07-01').format('YYYY-MM-DD'), side:  'BUY', amount: '100', price:  4.25, tax: 10.18, total: 435.18, attach: 10 },
      // { id: 4, share: 'CXSE3', date: moment('2024-08-20').format('YYYY-MM-DD'), side: 'SELL', amount:  '50', price:  0.65, tax: 10.05, total:  22.45, attach: 2  },
      // { id: 5, share: 'CXSE3', date: moment('2024-08-01').format('YYYY-MM-DD'), side:  'BUY', amount: '100', price:  0.48, tax: 10.56, total:  58.56, attach: '' },
      // { id: 6, share: 'ITSA4', date: moment('2024-08-23').format('YYYY-MM-DD'), side: 'SELL', amount:  '25', price: 29.50, tax:  8.45, total: 729.05, attach: '' },
    ]  
  }
  
  constructor() {
    super(StockCreateComponent, StockModifyComponent)

  }

  async ngAfterViewInit(): Promise<void> {
    console.error('StocksComponent -> ngAfterViewInit')

    console.log("listStocks: ", this.list.data)
  }

  override async evaluate(r: any, mode:string='add'):Promise<boolean> {
    // console.error('StocksComponent -> evaluate', r)
    
    console.error('StocksComponent -> evaluate', r.share)

    const exists = this.list.data.filter((i: any)=>{ return i.id == r.id })[0]
    console.error('StocksComponent -> evaluate', 'exists', exists?.id == r.id)

    var list:any[] = [...this.list.data]
    if(exists==undefined)
      list.push(r)
    if(exists!=undefined)
      list = [...this.list.data.filter((i: any)=>{ return i.id != r.id }), r]

    let amount:number = 0;
    await list.forEach((e:any) => {      
      if(e.share == r.share) {
        if(e.side == 'BUY')
          amount = amount + parseInt(e.amount)
        
        if(e.side == 'SELL')
          amount = amount - parseInt(e.amount)
      }
    })

    console.warn('StocksComponent -> evaluate', r.share, amount, amount >= 0)
    return await amount >= 0
  }
  
}
